import { getGoogleOAuthClientId } from './googleOAuthClientId';

/** Use static import.meta.env.* access only — dynamic keys pull every VITE_* into the bundle. */
function hasGoogleClientIdEnv(): boolean {
  if (typeof import.meta === 'undefined') return false;
  const v = import.meta.env.VITE_GOOGLE_CLIENT_ID;
  return typeof v === 'string' && v.trim().length > 0;
}

/**
 * In development, warn in console if required env vars are missing.
 * Does not throw; only logs.
 */
export function checkEnv(): void {
  if (typeof window === 'undefined') return;

  if (import.meta.env.PROD === true && import.meta.env.VITE_BYPASS_SUBSCRIPTION_GATING === 'true') {
    console.error(
      '[DoneGrading] VITE_BYPASS_SUBSCRIPTION_GATING is set in a production build. Subscription gating is disabled — remove this before App Store / Play release.'
    );
  }

  if (
    import.meta.env.PROD === true &&
    (import.meta.env.VITE_GRADING_ONLY === 'true' ||
      import.meta.env.VITE_GRADING_ONLY_MODE === 'true' ||
      import.meta.env.VITE_DEMO_GRADE_ONLY === 'true')
  ) {
    console.info(
      '[DoneGrading] Grading-only product build — non-Grade modules are not mounted in the UI.'
    );
  }

  const isDev =
    import.meta.env.DEV === true ||
    import.meta.env.MODE === 'development' ||
    /localhost|127\.0\.0\.1/.test(window.location?.host || '');
  if (!isDev) return;

  if (!hasGoogleClientIdEnv()) {
    console.warn(
      '[DoneGrading] Missing recommended env in development: VITE_GOOGLE_CLIENT_ID',
      '— copy .env.example to .env.local and set values.'
    );
  }

  console.info(
    '[DoneGrading] Scan grading + Gemini use `/api/*` on the Node server. Terminal 1: `node server.js` (loads `.env` + `.env.local`). Terminal 2: `npm run dev` → http://localhost:5173 (proxies `/api` to :8080).'
  );

  if (!getGoogleOAuthClientId()) {
    console.warn(
      '[DoneGrading] VITE_GOOGLE_CLIENT_ID is missing or invalid — Google sign-in will fail with invalid_client.',
      'Set it in .env.local (same OAuth Web client as production). In GCP, add your exact javascript_origin and redirect_uri — see .env.example; dev logs them on sign-in click.',
      'See .env.example.'
    );
  } else {
    const oauthProjectNum = getGoogleOAuthClientId()!.split('-')[0];
    const firebaseSender = String(import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '').trim();
    if (firebaseSender && oauthProjectNum && oauthProjectNum !== firebaseSender) {
      console.warn(
        `[DoneGrading] OAuth client project (${oauthProjectNum}) differs from Firebase project number (${firebaseSender}). Enable Google Classroom API on the OAuth client's GCP project:`,
        `https://console.cloud.google.com/apis/library/classroom.googleapis.com?project=${oauthProjectNum}`
      );
    }
  }
}
